import { Component, Input, OnInit, forwardRef } from '@angular/core';
import {
	FormBuilder,
	ControlValueAccessor,
	NG_VALUE_ACCESSOR,
	FormGroup,
	Validators,
} from '@angular/forms';
import { EmailAddress } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { emailAddressFormConfig } from '../email-address.component';
import { takeUntil, map } from 'rxjs/operators';
import { some } from 'lodash';

@Component({
	selector: 'rpshared-primary-email-address',
	templateUrl: './primary-email-address.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PrimaryEmailAddressComponent),
			multi: true,
		},
	],
})
export class PrimaryEmailAddressComponent extends SelfDestruct
	implements ControlValueAccessor, OnInit {
	
	@Input() emailRequired = true;
	private _emailAddresses: EmailAddress[] = [];

	form: FormGroup;

	constructor(private readonly fb: FormBuilder) {
		super();
	}

	ngOnInit() {
		const formConfig = {...emailAddressFormConfig};
		if(this.emailRequired === false) {
			formConfig.email = ['', [Validators.email]];
		}
		this.form = this.fb.group(formConfig) as FormGroup;
	}

	// model --> view
	writeValue(value: EmailAddress[]): void {
		this._emailAddresses = [...value];
		if (this._emailAddresses && this._emailAddresses.length > 0) {
			const primaryIndex = Math.max(
				this._emailAddresses.findIndex((e) => e.isPrimary),
				0
			);
			this.form.patchValue(this._emailAddresses[primaryIndex]);
			this._emailAddresses.splice(primaryIndex, 1);
		}
	}

	// view --> model
	registerOnChange(fn: (value: EmailAddress[]) => void) {
		this.form.valueChanges
			.pipe(
				map(({ isPrimary: _isPrimary, ...e }) =>
					some(e)
						? [...this._emailAddresses, { ...e, isPrimary: true }]
						: this._emailAddresses
				),
				takeUntil(this.destroyed)
			)
			.subscribe(fn);
	}
	registerOnTouched(fn: () => void) {
		this.onTouched = fn;
	}

	onTouched: () => void = () => {};
}
